import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { DateRange } from '@rp/shared/models';

import { ButtonComponent } from '../../button';
import { datePickerPresets } from './date-picker-presets';

@Component({
  selector: 'rp-date-picker-actions',
  standalone: true,
  templateUrl: './date-picker-actions.component.html',
  styleUrl: './date-picker-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, TranslateModule],
})
export class DatePickerActionsComponent {
  readonly presets = signal(datePickerPresets);

  selectPreset = output<DateRange>();

  onPresetSelected(selectedDate: DateRange): void {
    this.selectPreset.emit(selectedDate);
  }
}
